const Oeuvre_words  = {
    fr: {
        o_ADAD_HANNAH: {
            0 : 'Portrait individuel' ,
            1 : 'Vidéo',
            2 : 'Enfant',
            3 : 'Extérieur',
            4 : 'Terrain de soccer',
            5 : 'Ciel',
            6 : 'Ballon',
            7 : 'Pose',
            8 : 'Sport',
            9 : 'Attente',
            10 : 'Arrêt',
            11 : 'Espadrilles',
        },
        o_ANNIE_BAILLARGEON: {
            0 : 'yo',
            1 : 'lipsum',
            2 : 'alicam',
            3 : 'ticidunt',
            4 : 'nullam',
            5 : 'nullam1',
            6 : 'nullam2',
            7 : 'nullam3',
            8 : 'nullam4'
        },
        o_CLAUDIE_GAGNON: {
            0 : 'yo',
            1 : 'lipsum',
            2 : 'alicam',
            3 : 'ticidunt',
            4 : 'nullam',
            5 : 'nullam1',
            6 : 'nullam2',
            7 : 'nullam3',
            8 : 'nullam4'
        },
        o_HUA_JIN: {
            0 : 'Duo',
            1 : 'Adulte',
            2 : 'Enfant',
            3 : 'Debout',
            4 : 'Chine',
            5 : 'Costumes',
            6 : 'Rose',
            7 : 'Maquillage',
            8 : 'Coiffure',
            9 : 'Spectacle',
            10 : 'Traditions culturelles',
            11 : 'Jardin',
        },
        o_JJ_LEVINE: {
            0 :'Portrait de famille', 
            1 :'Trio',
            2 :'Enfant',
            3 :'Parents',
            4 :'Maison',
            5 :'Fleurs',
            6 :'Livres',
            7 :'Décoration',
            8 :'Tatouages',
            9 :'Sofa',
            10 :'Assis',
            11 :'Pieds nus',
        },
        o_JONAS_ST_MICHAEL: {
            0 : 'yo',
            1 : 'lipsum',
            2 : 'alicam',
            3 : 'ticidunt',
            4 : 'nullam',
            5 : 'nullam1',
            6 : 'nullam2',
            7 : 'nullam3',
            8 : 'nullam4'
        },
        o_PATRICK_BERNATCHEZ: {
            0 : 'yo',
            1 : 'lipsum',
            2 : 'alicam',
            3 : 'ticidunt',
            4 : 'nullam',
            5 : 'nullam1',
            6 : 'nullam2',
            7 : 'nullam3',
            8 : 'nullam4'
        },
        o_SKAWENNATI: {
            0 : 'yo',
            1 : 'lipsum',
            2 : 'alicam',
            3 : 'ticidunt',
            4 : 'nullam',
            5 : 'nullam1',
            6 : 'nullam2',
            7 : 'nullam3',
            8 : 'nullam4'
        },
        o_MARISA_PORTOLESE: {
            0 : 'Femme',
            1 : 'Enfant',
            2 : 'Intérieur',
            3 : 'Extérieur',
            4 : 'Plantes',
            5 : 'Fenêtre',
            6 : 'Maison',
            7 : 'Chien',
            8 : 'Robe',
            8 : 'Ressemblances',
            10 : 'Noir et blanc',
            11 : 'Couleurs',
        },
        o_MARISA_PORTOLESE_02: {
            0 : 'Femme',
            1 : 'Enfant',
            2 : 'Intérieur',
            3 : 'Extérieur',
            4 : 'Plantes',
            5 : 'Fenêtre',
            6 : 'Maison',
            7 : 'Chien',
            8 : 'Robe',
            8 : 'Ressemblances',
            10 : 'Noir et blanc',
            11 : 'Couleurs',
        },
        o_MORIDJA_KITENGE_BANZA: {
            0 : 'Autoportrait',
            1 : 'RDC',
            2 : 'Décor',
            3 : 'Couleurs',
            4 : 'Motif',
            5 : 'Cravate',
            6 : 'Peintures',
            7 : 'Saisons',
            8 : 'Neige',
            9 : 'Arbre',
            10 : 'Assis',
            11 : 'Identité',
        },
        o_MORIDJA_KITENGE_BANZA_02: {
            0 : 'Autoportrait',
            1 : 'RDC',
            2 : 'Décor',
            3 : 'Couleurs',
            4 : 'Motif',
            5 : 'Cravate',
            6 : 'Peintures',
            7 : 'Saisons',
            8 : 'Neige',
            9 : 'Arbre',
            10 : 'Assis',
            11 : 'Identité',
        }     
    },
    en: {
        o_ADAD_HANNAH: {
            0 : 'Individual portrait',
            1 : 'Video',
            2 : 'Child',
            3 : 'Outside',
            4 : 'Soccer field',
            5 : 'Sky',
            6 : 'Ball',
            7 : 'Pose',
            8 : 'Sport',
            9 : 'Waiting',
            10 : 'Still',
            11 : 'Sneakers',
        },
        o_ANNIE_BAILLARGEON: {
            0 : 'yo',
            1 : 'lipsum',
            2 : 'alicam',
            3 : 'ticidunt',
            4 : 'nullam',
            5 : 'nullam1',
            6 : 'nullam2',
            7 : 'nullam3',
            8 : 'nullam4'
        },
        o_CLAUDIE_GAGNON: {
            0 : 'yo',
            1 : 'lipsum',
            2 : 'alicam',
            3 : 'ticidunt',
            4 : 'nullam',
            5 : 'nullam1',
            6 : 'nullam2',
            7 : 'nullam3',
            8 : 'nullam4'
        },
        o_HUA_JIN: {
            0 : 'Duo',
            1 : 'Adult',
            2 : 'Child',
            3 : 'Standing',
            4 : 'China',
            5 : 'Costumes',
            6 : 'Pink',
            7 : 'Makeup',
            8 : 'Headdress', 
            9 : 'Show',
            10 : 'Cultural traditions', 
            11 : 'Garden',
        },
        o_JJ_LEVINE: {
            0 :'Family portrait', 
            1 :'Trio',
            2 :'Child',
            3 :'Parents',
            4 :'Home',
            5 :'Flowers',
            6 :'Books',
            7 :'Décor',
            8 :'Tattoos',
            9 :'Sofa',
            10 :'Sitting', 
            11 :'Barefoot',
        },
        o_JONAS_ST_MICHAEL: {
            0 : 'yo',
            1 : 'lipsum',
            2 : 'alicam',
            3 : 'ticidunt',
            4 : 'nullam',
            5 : 'nullam1',
            6 : 'nullam2',
            7 : 'nullam3',
            8 : 'nullam4'
        },
        o_PATRICK_BERNATCHEZ: {
            0 : 'yo',
            1 : 'lipsum',
            2 : 'alicam',
            3 : 'ticidunt',
            4 : 'nullam',
            5 : 'nullam1',
            6 : 'nullam2',
            7 : 'nullam3',
            8 : 'nullam4'
        },
        o_SKAWENNATI: {
            0 : 'yo',
            1 : 'lipsum',
            2 : 'alicam',
            3 : 'ticidunt',
            4 : 'nullam',
            5 : 'nullam1',
            6 : 'nullam2',
            7 : 'nullam3',
            8 : 'nullam4'
        },
        o_MARISA_PORTOLESE: {
            0 :'Woman', 
            1 :'Child',
            2 :'Inside',
            3 :'Outside', 
            4 :'Plants',
            5 :'Window',
            6 :'House',
            7 :'Dog',
            8 :'Dress',
            9 :'Similarities',
            10 :'Black and white', 
            11 :'Colours',
        },
        o_MARISA_PORTOLESE_02: {
            0 :'Woman', 
            1 :'Child',
            2 :'Inside',
            3 :'Outside', 
            4 :'Plants',
            5 :'Window',
            6 :'House',
            7 :'Dog',
            8 :'Dress',
            9 :'Similarities',
            10 :'Black and white', 
            11 :'Colours',
        },
        o_MORIDJA_KITENGE_BANZA: {
            0 : 'Self-portrait',
            1 : 'DRC',
            2 : 'Setting',
            3 : 'Colours',
            4 : 'Patterns',
            5 : 'Tie',
            6 : 'Paintings',
            7 : 'Seasons',
            8 : 'Snow',
            9 : 'Tree',
            10 : 'Sitting',
            11 : 'Identity',

        },
        o_MORIDJA_KITENGE_BANZA_02: {
            0 : 'Self-portrait',
            1 : 'DRC',
            2 : 'Setting',
            3 : 'Colours',
            4 : 'Patterns',
            5 : 'Tie',
            6 : 'Paintings',
            7 : 'Seasons',
            8 : 'Snow',
            9 : 'Tree',
            10 : 'Sitting',
            11 : 'Identity',
        }  
    }
}

export { Oeuvre_words }





// WEBPACK FOOTER //
// ./src/components/defis/js/Words.js